
export const qouraPixelTrack = (url) => {
    window.qp = window.qp || [];
    window.qp('track', 'ViewContent');
    // console.log("qp", window.qp.qp, window)
} 

export const qouraPixelEvent = (total_amount, currency, transaction_id, email, phone_number) => {
    window.email = email;
    window.phone_number = phone_number
    window.qp = window.qp || [];
    window.qp('track', 'Purchase', {value: total_amount, currency: currency});
} 